import React, { useCallback, useMemo } from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'
import { useSelector } from 'hooks/redux'
import { FlexRow } from 'components/patterns/Layout'
import strings from 'utils/strings'
import { INDICATOR } from 'constants/dash'
import { Header } from 'components/patterns/Typography'
import { getCustomSwitchParts } from 'selectors/dash'
import CustomSwitchDetailCard from 'components/SwitchAndGauge/DashDrawer/CustomSwitchDetailCard'

const CustomSwitchGraphicsList = ({
  onSwitchSelection,
  selectedPart,
  isError,
  panelNumber,
}) => {
  const switchParts = useSelector(getCustomSwitchParts)

  const handleSwitchSelect = useCallback(
    (partNumber, description) => {
      onSwitchSelection(partNumber, description)
    },
    [onSwitchSelection]
  )

  const renderSwitchDetailsCard = useMemo(
    () =>
      !isEmpty(switchParts) &&
      switchParts.map((customSwitch) => {
        const { id, description, capPartNumber, capType } = customSwitch
        const key = `${capPartNumber}-${description.split(' ').join('-')}`
        return (
          <CustomSwitchDetailCard
            className={`switch-${id}`}
            key={key}
            partNumber={capPartNumber}
            panelNumber={panelNumber}
            description={description}
            selectedPart={selectedPart}
            isCustomIndicator={capType === INDICATOR}
            onSwitchSelection={handleSwitchSelect}
          />
        )
      }),
    [handleSwitchSelect, selectedPart, switchParts, panelNumber]
  )

  if (isError) return null

  if (switchParts.length === 0) return null

  return (
    <div>
      <Header type="h2">{strings.select_graphic}</Header>
      <StyledCardContainer>{renderSwitchDetailsCard}</StyledCardContainer>
    </div>
  )
}

CustomSwitchGraphicsList.propTypes = {
  onSwitchSelection: PropTypes.func,
  selectedPart: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  isError: PropTypes.bool,
  panelNumber: PropTypes.string,
}

export default CustomSwitchGraphicsList

const StyledCardContainer = styled(FlexRow)`
  &&&& {
    width: 100%;
    margin-top: 16px;
  }
`
